import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

export const getChipOptions = ({ palette }: Theme) => {
  const chipComponent = {
    styleOverrides: {
      root: () => {
        return {
          height: 'auto',
          borderRadius: '30px',
          backgroundColor: palette.chip.main,
          [`& ${globalClasses.chipAvatar}`]: {
            marginLeft: 0,
          },
          [`& ${globalClasses.chipLabel}`]: {
            padding: 0,
          },
        };
      },
      sizeSmall: {
        padding: '4px 8px',
        [`& ${globalClasses.chipAvatar}`]: {
          marginRight: '4px',
        },
      },
      sizeMedium: {
        padding: '8px 16px',
        [`& ${globalClasses.chipAvatar}`]: {
          marginRight: '8px',
        },
      },
    },
  };

  return { chipComponent };
};
